import React, { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { decodeJwt, isExpired, refreshKeycloakTokens, getKeycloakTokens, clearAllAuth } from "../services/authTokens";
import tokenService from "../services/tokenService";

export default function Protected(props) {
  const navigate = useNavigate();
  const { Page } = props;

    const isRedirectingRef = useRef(false);

    const smoothLogout = useCallback(() => {
        if (isRedirectingRef.current) return;
        isRedirectingRef.current = true;
        try {
            clearAllAuth();
        } catch {}
        localStorage.setItem("loginStatus", "Session expired. Please login again.");
        navigate("/", { replace: true });
    }, [navigate]);

    useEffect(() => {
        const checkSession = async () => {
            if (isRedirectingRef.current) return;

            const loggedIn = localStorage.getItem("login") === "true";
            if (!loggedIn) {
                smoothLogout();
                return;
            }

            const { accessToken } = getKeycloakTokens();
            const legacyToken = localStorage.getItem("token");

            // If neither KC tokens nor legacy token, logout
            if (!accessToken && !legacyToken) {
                smoothLogout();
                return;
            }

            // If we have a KC access token, ensure it's valid and session is alive
            if (accessToken) {
                try {
                    const payload = decodeJwt(accessToken);
                    const expired = isExpired(payload);
                    if (expired) {
                        const ok = await refreshKeycloakTokens();
                        if (!ok) {
                            smoothLogout();
                            return;
                        }
                    }
                } catch {
                    // decoding failed -> try refresh, else logout
                    const ok = await refreshKeycloakTokens();
                    if (!ok) {
                        smoothLogout();
                        return;
                    }
                }

                // Lightweight server-side session validation
                try {
                    const { accessToken: freshAccess } = getKeycloakTokens();
                    await tokenService.getUserInfo(freshAccess || accessToken);
                } catch {
                    // access token no longer valid server-side
                    const ok = await refreshKeycloakTokens();
                    if (!ok) {
                        smoothLogout();
                        return;
                    }
                }
            }
        };

        checkSession();
        const interval = setInterval(checkSession, 30000);
        return () => clearInterval(interval);
    }, [navigate, smoothLogout]);

  return <Page />;
}
